import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FileSizePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    let s = Number(value);
    let result: any;
    if(s < 1024){
      result = s + ' B';
    } else if(s < 1024*1024){
      result = (s/1024).toFixed(1) + ' KB';
    } else {
      result = (s/1024/1024).toFixed(1) + ' MB';
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/file-size/file-size.ts